import { render, staticRenderFns } from "./LoadingAnimated.vue?vue&type=template&id=686ba4c6&"
import script from "./LoadingAnimated.vue?vue&type=script&lang=js&"
export * from "./LoadingAnimated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports